export const currency = "AED"

export const Countries = [
    { label: 'Afghanistan', value: 'Afghanistan' },
    { label: 'Åland Islands', value: 'Åland Islands' },
    { label: 'Albania', value: 'Albania' },
    { label: 'Algeria', value: 'Algeria' },
    { label: 'American Samoa', value: 'American Samoa' },
    { label: 'AndorrA', value: 'AndorrA' },
    { label: 'Angola', value: 'Angola' },
    { label: 'Anguilla', value: 'Anguilla' },
    { label: 'Antarctica', value: 'Antarctica' },
    { label: 'Antigua and Barbuda', value: 'Antigua and Barbuda' },
    { label: 'Argentina', value: 'Argentina' },
    { label: 'Armenia', value: 'Armenia' },
    { label: 'Aruba', value: 'Aruba' },
    { label: 'Australia', value: 'Australia' },
    { label: 'Austria', value: 'Austria' },
    { label: 'Azerbaijan', value: 'Azerbaijan' },
    { label: 'Bahamas', value: 'Bahamas' },
    { label: 'Bahrain', value: 'Bahrain' },
    { label: 'Bangladesh', value: 'Bangladesh' },
    { label: 'Barbados', value: 'Barbados' },
    { label: 'Belarus', value: 'Belarus' },
    { label: 'Belgium', value: 'Belgium' },
    { label: 'Belize', value: 'Belize' },
    { label: 'Benin', value: 'Benin' },
    { label: 'Bermuda', value: 'Bermuda' },
    { label: 'Bhutan', value: 'Bhutan' },
    { label: 'Bolivia', value: 'Bolivia' },
    { label: 'Bosnia and Herzegovina', value: 'Bosnia and Herzegovina' },
    { label: 'Botswana', value: 'Botswana' },
    { label: 'Bouvet Island', value: 'Bouvet Island' },
    { label: 'Brazil', value: 'Brazil' },
    { label: 'British Indian Ocean Territory', value: 'British Indian Ocean Territory' },
    { label: 'Brunei Darussalam', value: 'Brunei Darussalam' },
    { label: 'Bulgaria', value: 'Bulgaria' },
    { label: 'Burkina Faso', value: 'Burkina Faso' },
    { label: 'Burundi', value: 'Burundi' },
    { label: 'Cambodia', value: 'Cambodia' },
    { label: 'Cameroon', value: 'Cameroon' },
    { label: 'Canada', value: 'Canada' },
    { label: 'Cape Verde', value: 'Cape Verde' },
    { label: 'Cayman Islands', value: 'Cayman Islands' },
    { label: 'Central African Republic', value: 'Central African Republic' },
    { label: 'Chad', value: 'Chad' },
    { label: 'Chile', value: 'Chile' },
    { label: 'China', value: 'China' },
    { label: 'Christmas Island', value: 'Christmas Island' },
    { label: 'Cocos (Keeling) Islands', value: 'Cocos (Keeling) Islands' },
    { label: 'Colombia', value: 'Colombia' },
    { label: 'Comoros', value: 'Comoros' },
    { label: 'Congo', value: 'Congo' },
    { label: 'Congo, The Democratic Republic of the', value: 'Congo, The Democratic Republic of the' },
    { label: 'Cook Islands', value: 'Cook Islands' },
    { label: 'Costa Rica', value: 'Costa Rica' },
    { label: 'Cote D\'Ivoire', value: 'Cote D\'Ivoire' },
    { label: 'Croatia', value: 'Croatia' },
    { label: 'Cuba', value: 'Cuba' },
    { label: 'Cyprus', value: 'Cyprus' },
    { label: 'Czech Republic', value: 'Czech Republic' },
    { label: 'Denmark', value: 'Denmark' },
    { label: 'Djibouti', value: 'Djibouti' },
    { label: 'Dominica', value: 'Dominica' },
    { label: 'Dominican Republic', value: 'Dominican Republic' },
    { label: 'Ecuador', value: 'Ecuador' },
    { label: 'Egypt', value: 'Egypt' },
    { label: 'El Salvador', value: 'El Salvador' },
    { label: 'Equatorial Guinea', value: 'Equatorial Guinea' },
    { label: 'Eritrea', value: 'Eritrea' },
    { label: 'Estonia', value: 'Estonia' },
    { label: 'Ethiopia', value: 'Ethiopia' },
    { label: 'Falkland Islands (Malvinas)', value: 'Falkland Islands (Malvinas)' },
    { label: 'Faroe Islands', value: 'Faroe Islands' },
    { label: 'Fiji', value: 'Fiji' },
    { label: 'Finland', value: 'Finland' },
    { label: 'France', value: 'France' },
    { label: 'French Guiana', value: 'French Guiana' },
    { label: 'French Polynesia', value: 'French Polynesia' },
    { label: 'French Southern Territories', value: 'French Southern Territories' },
    { label: 'Gabon', value: 'Gabon' },
    { label: 'Gambia', value: 'Gambia' },
    { label: 'Georgia', value: 'Georgia' },
    { label: 'Germany', value: 'Germany' },
    { label: 'Ghana', value: 'Ghana' },
    { label: 'Gibraltar', value: 'Gibraltar' },
    { label: 'Greece', value: 'Greece' },
    { label: 'Greenland', value: 'Greenland' },
    { label: 'Grenada', value: 'Grenada' },
    { label: 'Guadeloupe', value: 'Guadeloupe' },
    { label: 'Guam', value: 'Guam' },
    { label: 'Guatemala', value: 'Guatemala' },
    { label: 'Guernsey', value: 'Guernsey' },
    { label: 'Guinea', value: 'Guinea' },
    { label: 'Guinea-Bissau', value: 'Guinea-Bissau' },
    { label: 'Guyana', value: 'Guyana' },
    { label: 'Haiti', value: 'Haiti' },
    { label: 'Heard Island and Mcdonald Islands', value: 'Heard Island and Mcdonald Islands' },
    { label: 'Holy See (Vatican City State)', value: 'Holy See (Vatican City State)' },
    { label: 'Honduras', value: 'Honduras' },
    { label: 'Hong Kong', value: 'Hong Kong' },
    { label: 'Hungary', value: 'Hungary' },
    { label: 'Iceland', value: 'Iceland' },
    { label: 'India', value: 'India' },
    { label: 'Indonesia', value: 'Indonesia' },
    { label: 'Iran, Islamic Republic Of', value: 'Iran, Islamic Republic Of' },
    { label: 'Iraq', value: 'Iraq' },
    { label: 'Ireland', value: 'Ireland' },
    { label: 'Isle of Man', value: 'Isle of Man' },
    { label: 'Israel', value: 'Israel' },
    { label: 'Italy', value: 'Italy' },
    { label: 'Jamaica', value: 'Jamaica' },
    { label: 'Japan', value: 'Japan' },
    { label: 'Jersey', value: 'Jersey' },
    { label: 'Jordan', value: 'Jordan' },
    { label: 'Kazakhstan', value: 'Kazakhstan' },
    { label: 'Kenya', value: 'Kenya' },
    { label: 'Kiribati', value: 'Kiribati' },
    { label: 'Korea, Democratic People\'S Republic of', value: 'Korea, Democratic People\'S Republic of' },
    { label: 'Korea, Republic of', value: 'Korea, Republic of' },
    { label: 'Kuwait', value: 'Kuwait' },
    { label: 'Kyrgyzstan', value: 'Kyrgyzstan' },
    { label: 'Lao People\'S Democratic Republic', value: 'Lao People\'S Democratic Republic' },
    { label: 'Latvia', value: 'Latvia' },
    { label: 'Lebanon', value: 'Lebanon' },
    { label: 'Lesotho', value: 'Lesotho' },
    { label: 'Liberia', value: 'Liberia' },
    { label: 'Libyan Arab Jamahiriya', value: 'Libyan Arab Jamahiriya' },
    { label: 'Liechtenstein', value: 'Liechtenstein' },
    { label: 'Lithuania', value: 'Lithuania' },
    { label: 'Luxembourg', value: 'Luxembourg' },
    { label: 'Macao', value: 'Macao' },
    { label: 'Macedonia, The Former Yugoslav Republic of', value: 'Macedonia, The Former Yugoslav Republic of' },
    { label: 'Madagascar', value: 'Madagascar' },
    { label: 'Malawi', value: 'Malawi' },
    { label: 'Malaysia', value: 'Malaysia' },
    { label: 'Maldives', value: 'Maldives' },
    { label: 'Mali', value: 'Mali' },
    { label: 'Malta', value: 'Malta' },
    { label: 'Marshall Islands', value: 'Marshall Islands' },
    { label: 'Martinique', value: 'Martinique' },
    { label: 'Mauritania', value: 'Mauritania' },
    { label: 'Mauritius', value: 'Mauritius' },
    { label: 'Mayotte', value: 'Mayotte' },
    { label: 'Mexico', value: 'Mexico' },
    { label: 'Micronesia, Federated States of', value: 'Micronesia, Federated States of' },
    { label: 'Moldova, Republic of', value: 'Moldova, Republic of' },
    { label: 'Monaco', value: 'Monaco' },
    { label: 'Mongolia', value: 'Mongolia' },
    { label: 'Montserrat', value: 'Montserrat' },
    { label: 'Morocco', value: 'Morocco' },
    { label: 'Mozambique', value: 'Mozambique' },
    { label: 'Myanmar', value: 'Myanmar' },
    { label: 'Namibia', value: 'Namibia' },
    { label: 'Nauru', value: 'Nauru' },
    { label: 'Nepal', value: 'Nepal' },
    { label: 'Netherlands', value: 'Netherlands' },
    { label: 'Netherlands Antilles', value: 'Netherlands Antilles' },
    { label: 'New Caledonia', value: 'New Caledonia' },
    { label: 'New Zealand', value: 'New Zealand' },
    { label: 'Nicaragua', value: 'Nicaragua' },
    { label: 'Niger', value: 'Niger' },
    { label: 'Nigeria', value: 'Nigeria' },
    { label: 'Niue', value: 'Niue' },
    { label: 'Norfolk Island', value: 'Norfolk Island' },
    { label: 'Northern Mariana Islands', value: 'Northern Mariana Islands' },
    { label: 'Norway', value: 'Norway' },
    { label: 'Oman', value: 'Oman' },
    { label: 'Pakistan', value: 'Pakistan' },
    { label: 'Palau', value: 'Palau' },
    { label: 'Palestinian Territory, Occupied', value: 'Palestinian Territory, Occupied' },
    { label: 'Panama', value: 'Panama' },
    { label: 'Papua New Guinea', value: 'Papua New Guinea' },
    { label: 'Paraguay', value: 'Paraguay' },
    { label: 'Peru', value: 'Peru' },
    { label: 'Philippines', value: 'Philippines' },
    { label: 'Pitcairn', value: 'Pitcairn' },
    { label: 'Poland', value: 'Poland' },
    { label: 'Portugal', value: 'Portugal' },
    { label: 'Puerto Rico', value: 'Puerto Rico' },
    { label: 'Qatar', value: 'Qatar' },
    { label: 'Reunion', value: 'Reunion' },
    { label: 'Romania', value: 'Romania' },
    { label: 'Russian Federation', value: 'Russian Federation' },
    { label: 'RWANDA', value: 'RWANDA' },
    { label: 'Saint Helena', value: 'Saint Helena' },
    { label: 'Saint Kitts and Nevis', value: 'Saint Kitts and Nevis' },
    { label: 'Saint Lucia', value: 'Saint Lucia' },
    { label: 'Saint Pierre and Miquelon', value: 'Saint Pierre and Miquelon' },
    { label: 'Saint Vincent and the Grenadines', value: 'Saint Vincent and the Grenadines' },
    { label: 'Samoa', value: 'Samoa' },
    { label: 'San Marino', value: 'San Marino' },
    { label: 'Sao Tome and Principe', value: 'Sao Tome and Principe' },
    { label: 'Saudi Arabia', value: 'Saudi Arabia' },
    { label: 'Senegal', value: 'Senegal' },
    { label: 'Serbia and Montenegro', value: 'Serbia and Montenegro' },
    { label: 'Seychelles', value: 'Seychelles' },
    { label: 'Sierra Leone', value: 'Sierra Leone' },
    { label: 'Singapore', value: 'Singapore' },
    { label: 'Slovakia', value: 'Slovakia' },
    { label: 'Slovenia', value: 'Slovenia' },
    { label: 'Solomon Islands', value: 'Solomon Islands' },
    { label: 'Somalia', value: 'Somalia' },
    { label: 'South Africa', value: 'South Africa' },
    { label: 'South Georgia and the South Sandwich Islands', value: 'South Georgia and the South Sandwich Islands' },
    { label: 'Spain', value: 'Spain' },
    { label: 'Sri Lanka', value: 'Sri Lanka' },
    { label: 'Sudan', value: 'Sudan' },
    { label: 'Suriname', value: 'Suriname' },
    { label: 'Svalbard and Jan Mayen', value: 'Svalbard and Jan Mayen' },
    { label: 'Swaziland', value: 'Swaziland' },
    { label: 'Sweden', value: 'Sweden' },
    { label: 'Switzerland', value: 'Switzerland' },
    { label: 'Syrian Arab Republic', value: 'Syrian Arab Republic' },
    { label: 'Taiwan, Province of China', value: 'Taiwan, Province of China' },
    { label: 'Tajikistan', value: 'Tajikistan' },
    { label: 'Tanzania, United Republic of', value: 'Tanzania, United Republic of' },
    { label: 'Thailand', value: 'Thailand' },
    { label: 'Timor-Leste', value: 'Timor-Leste' },
    { label: 'Togo', value: 'Togo' },
    { label: 'Tokelau', value: 'Tokelau' },
    { label: 'Tonga', value: 'Tonga' },
    { label: 'Trinidad and Tobago', value: 'Trinidad and Tobago' },
    { label: 'Tunisia', value: 'Tunisia' },
    { label: 'Turkey', value: 'Turkey' },
    { label: 'Turkmenistan', value: 'Turkmenistan' },
    { label: 'Turks and Caicos Islands', value: 'Turks and Caicos Islands' },
    { label: 'Tuvalu', value: 'Tuvalu' },
    { label: 'Uganda', value: 'Uganda' },
    { label: 'Ukraine', value: 'Ukraine' },
    { label: 'United Arab Emirates', value: 'United Arab Emirates' },
    { label: 'United Kingdom', value: 'United Kingdom' },
    { label: 'United States', value: 'United States' },
    { label: 'United States Minor Outlying Islands', value: 'United States Minor Outlying Islands' },
    { label: 'Uruguay', value: 'Uruguay' },
    { label: 'Uzbekistan', value: 'Uzbekistan' },
    { label: 'Vanuatu', value: 'Vanuatu' },
    { label: 'Venezuela', value: 'Venezuela' },
    { label: 'Viet Nam', value: 'Viet Nam' },
    { label: 'Virgin Islands, British', value: 'Virgin Islands, British' },
    { label: 'Virgin Islands, U.S.', value: 'Virgin Islands, U.S.' },
    { label: 'Wallis and Futuna', value: 'Wallis and Futuna' },
    { label: 'Western Sahara', value: 'Western Sahara' },
    { label: 'Yemen', value: 'Yemen' },
    { label: 'Zambia', value: 'Zambia' },
    { label: 'Zimbabwe', value: 'Zimbabwe' }
  ]
export const countriesWithCodeNumber = [
  {"name": "Afghanistan", "code": "AF", "dial_code": "+93"},
  {"name": "Albania", "code": "AL", "dial_code": "+355"},
  {"name": "Algeria", "code": "DZ", "dial_code": "+213"},
  {"name": "Andorra", "code": "AD", "dial_code": "+376"},
  {"name": "Angola", "code": "AO", "dial_code": "+244"},
  {"name": "Antigua and Barbuda", "code": "AG", "dial_code": "+1"},
  {"name": "Argentina", "code": "AR", "dial_code": "+54"},
  {"name": "Armenia", "code": "AM", "dial_code": "+374"},
  {"name": "Australia", "code": "AU", "dial_code": "+61"},
  {"name": "Austria", "code": "AT", "dial_code": "+43"},
  {"name": "Azerbaijan", "code": "AZ", "dial_code": "+994"},
  {"name": "Bahamas", "code": "BS", "dial_code": "+1"},
  {"name": "Bahrain", "code": "BH", "dial_code": "+973"},
  {"name": "Bangladesh", "code": "BD", "dial_code": "+880"},
  {"name": "Barbados", "code": "BB", "dial_code": "+1"},
  {"name": "Belarus", "code": "BY", "dial_code": "+375"},
  {"name": "Belgium", "code": "BE", "dial_code": "+32"},
  {"name": "Belize", "code": "BZ", "dial_code": "+501"},
  {"name": "Benin", "code": "BJ", "dial_code": "+229"},
  {"name": "Bhutan", "code": "BT", "dial_code": "+975"},
  {"name": "Bolivia", "code": "BO", "dial_code": "+591"},
  {"name": "Bosnia and Herzegovina", "code": "BA", "dial_code": "+387"},
  {"name": "Botswana", "code": "BW", "dial_code": "+267"},
  {"name": "Brazil", "code": "BR", "dial_code": "+55"},
  {"name": "Brunei", "code": "BN", "dial_code": "+673"},
  {"name": "Bulgaria", "code": "BG", "dial_code": "+359"},
  {"name": "Burkina Faso", "code": "BF", "dial_code": "+226"},
  {"name": "Burundi", "code": "BI", "dial_code": "+257"},
  {"name": "Cabo Verde", "code": "CV", "dial_code": "+238"},
  {"name": "Cambodia", "code": "KH", "dial_code": "+855"},
  {"name": "Cameroon", "code": "CM", "dial_code": "+237"},
  {"name": "Canada", "code": "CA", "dial_code": "+1"},
  {"name": "Central African Republic", "code": "CF", "dial_code": "+236"},
  {"name": "Chad", "code": "TD", "dial_code": "+235"},
  {"name": "Chile", "code": "CL", "dial_code": "+56"},
  {"name": "China", "code": "CN", "dial_code": "+86"},
  {"name": "Colombia", "code": "CO", "dial_code": "+57"},
  {"name": "Comoros", "code": "KM", "dial_code": "+269"},
  {"name": "Congo (Congo-Brazzaville)", "code": "CG", "dial_code": "+242"},
  {"name": "Congo (Congo-Kinshasa)", "code": "CD", "dial_code": "+243"},
  {"name": "Costa Rica", "code": "CR", "dial_code": "+506"},
  {"name": "Croatia", "code": "HR", "dial_code": "+385"},
  {"name": "Cuba", "code": "CU", "dial_code": "+53"},
  {"name": "Cyprus", "code": "CY", "dial_code": "+357"},
  {"name": "Czechia (Czech Republic)", "code": "CZ", "dial_code": "+420"},
  {"name": "Denmark", "code": "DK", "dial_code": "+45"},
  {"name": "Djibouti", "code": "DJ", "dial_code": "+253"},
  {"name": "Dominica", "code": "DM", "dial_code": "+1"},
  {"name": "Dominican Republic", "code": "DO", "dial_code": "+1"},
  {"name": "Ecuador", "code": "EC", "dial_code": "+593"},
  {"name": "Egypt", "code": "EG", "dial_code": "+20"},
  {"name": "El Salvador", "code": "SV", "dial_code": "+503"},
  {"name": "Equatorial Guinea", "code": "GQ", "dial_code": "+240"},
  {"name": "Eritrea", "code": "ER", "dial_code": "+291"},
  {"name": "Estonia", "code": "EE", "dial_code": "+372"},
  {"name": "Eswatini", "code": "SZ", "dial_code": "+268"},
  {"name": "Ethiopia", "code": "ET", "dial_code": "+251"},
  {"name": "Fiji", "code": "FJ", "dial_code": "+679"},
  {"name": "Finland", "code": "FI", "dial_code": "+358"},
  {"name": "France", "code": "FR", "dial_code": "+33"},
  {"name": "Gabon", "code": "GA", "dial_code": "+241"},
  {"name": "Gambia", "code": "GM", "dial_code": "+220"},
  {"name": "Georgia", "code": "GE", "dial_code": "+995"},
  {"name": "Germany", "code": "DE", "dial_code": "+49"},
  {"name": "Ghana", "code": "GH", "dial_code": "+233"},
  {"name": "Greece", "code": "GR", "dial_code": "+30"},
  {"name": "Grenada", "code": "GD", "dial_code": "+1"},
  {"name": "Guatemala", "code": "GT", "dial_code": "+502"},
  {"name": "Guinea", "code": "GN", "dial_code": "+224"},
  {"name": "Guinea-Bissau", "code": "GW", "dial_code": "+245"},
  {"name": "Guyana", "code": "GY", "dial_code": "+592"},
  {"name": "Haiti", "code": "HT", "dial_code": "+509"},
  {"name": "Holy See", "code": "VA", "dial_code": "+39"},
  {"name": "Honduras", "code": "HN", "dial_code": "+504"},
  {"name": "Hungary", "code": "HU", "dial_code": "+36"},
  {"name": "Iceland", "code": "IS", "dial_code": "+354"},
  {"name": "India", "code": "IN", "dial_code": "+91"},
  {"name": "Indonesia", "code": "ID", "dial_code": "+62"},
  {"name": "Iran", "code": "IR", "dial_code": "+98"},
  {"name": "Iraq", "code": "IQ", "dial_code": "+964"},
  {"name": "Ireland", "code": "IE", "dial_code": "+353"},
  {"name": "Israel", "code": "IL", "dial_code": "+972"},
  {"name": "Italy", "code": "IT", "dial_code": "+39"},
  {"name": "Jamaica", "code": "JM", "dial_code": "+1"},
  {"name": "Japan", "code": "JP", "dial_code": "+81"},
  {"name": "Jordan", "code": "JO", "dial_code": "+962"},
  {"name": "Kazakhstan", "code": "KZ", "dial_code": "+7"},
  {"name": "Kenya", "code": "KE", "dial_code": "+254"},
  {"name": "Kiribati", "code": "KI", "dial_code": "+686"},
  {"name": "Korea (North)", "code": "KP", "dial_code": "+850"},
  {"name": "Korea (South)", "code": "KR", "dial_code": "+82"},
  {"name": "Kuwait", "code": "KW", "dial_code": "+965"},
  {"name": "Kyrgyzstan", "code": "KG", "dial_code": "+996"},
  {"name": "Laos", "code": "LA", "dial_code": "+856"},
    {"name": "Latvia", "code": "LV", "dial_code": "+371"},
    {"name": "Lebanon", "code": "LB", "dial_code": "+961"},
    {"name": "Lesotho", "code": "LS", "dial_code": "+266"},
    {"name": "Liberia", "code": "LR", "dial_code": "+231"},
    {"name": "Libya", "code": "LY", "dial_code": "+218"},
    {"name": "Liechtenstein", "code": "LI", "dial_code": "+423"},
    {"name": "Lithuania", "code": "LT", "dial_code": "+370"},
    {"name": "Luxembourg", "code": "LU", "dial_code": "+352"},
    {"name": "Madagascar", "code": "MG", "dial_code": "+261"},
    {"name": "Malawi", "code": "MW", "dial_code": "+265"},
    {"name": "Malaysia", "code": "MY", "dial_code": "+60"},
    {"name": "Maldives", "code": "MV", "dial_code": "+960"},
    {"name": "Mali", "code": "ML", "dial_code": "+223"},
    {"name": "Malta", "code": "MT", "dial_code": "+356"},
    {"name": "Marshall Islands", "code": "MH", "dial_code": "+692"},
    {"name": "Mauritania", "code": "MR", "dial_code": "+222"},
    {"name": "Mauritius", "code": "MU", "dial_code": "+230"},
    {"name": "Mexico", "code": "MX", "dial_code": "+52"},
    {"name": "Micronesia", "code": "FM", "dial_code": "+691"},
    {"name": "Moldova", "code": "MD", "dial_code": "+373"},
    {"name": "Monaco", "code": "MC", "dial_code": "+377"},
    {"name": "Mongolia", "code": "MN", "dial_code": "+976"},
    {"name": "Montenegro", "code": "ME", "dial_code": "+382"},
    {"name": "Morocco", "code": "MA", "dial_code": "+212"},
    {"name": "Mozambique", "code": "MZ", "dial_code": "+258"},
    {"name": "Myanmar", "code": "MM", "dial_code": "+95"},
    {"name": "Namibia", "code": "NA", "dial_code": "+264"},
    {"name": "Nauru", "code": "NR", "dial_code": "+674"},
    {"name": "Nepal", "code": "NP", "dial_code": "+977"},
    {"name": "Netherlands", "code": "NL", "dial_code": "+31"},
    {"name": "New Zealand", "code": "NZ", "dial_code": "+64"},
    {"name": "Nicaragua", "code": "NI", "dial_code": "+505"},
    {"name": "Niger", "code": "NE", "dial_code": "+227"},
    {"name": "Nigeria", "code": "NG", "dial_code": "+234"},
    {"name": "North Macedonia", "code": "MK", "dial_code": "+389"},
    {"name": "Norway", "code": "NO", "dial_code": "+47"},
    {"name": "Oman", "code": "OM", "dial_code": "+968"},
    {"name": "Pakistan", "code": "PK", "dial_code": "+92"},
    {"name": "Palau", "code": "PW", "dial_code": "+680"},
    {"name": "Palestine", "code": "PS", "dial_code": "+970"},
    {"name": "Panama", "code": "PA", "dial_code": "+507"},
    {"name": "Papua New Guinea", "code": "PG", "dial_code": "+675"},
    {"name": "Paraguay", "code": "PY", "dial_code": "+595"},
    {"name": "Peru", "code": "PE", "dial_code": "+51"},
    {"name": "Philippines", "code": "PH", "dial_code": "+63"},
    {"name": "Poland", "code": "PL", "dial_code": "+48"},
    {"name": "Portugal", "code": "PT", "dial_code": "+351"},
    {"name": "Qatar", "code": "QA", "dial_code": "+974"},
    {"name": "Romania", "code": "RO", "dial_code": "+40"},
    {"name": "Russia", "code": "RU", "dial_code": "+7"},
    {"name": "Rwanda", "code": "RW", "dial_code": "+250"},
    {"name": "Saint Kitts and Nevis", "code": "KN", "dial_code": "+1"},
    {"name": "Saint Lucia", "code": "LC", "dial_code": "+1"},
    {"name": "Saint Vincent and the Grenadines", "code": "VC", "dial_code": "+1"},
    {"name": "Samoa", "code": "WS", "dial_code": "+685"},
    {"name": "San Marino", "code": "SM", "dial_code": "+378"},
    {"name": "Sao Tome and Principe", "code": "ST", "dial_code": "+239"},
    {"name": "Saudi Arabia", "code": "SA", "dial_code": "+966"},
    {"name": "Senegal", "code": "SN", "dial_code": "+221"},
    {"name": "Serbia", "code": "RS", "dial_code": "+381"},
    {"name": "Seychelles", "code": "SC", "dial_code": "+248"},
    {"name": "Sierra Leone", "code": "SL", "dial_code": "+232"},
    {"name": "Singapore", "code": "SG", "dial_code": "+65"},
    {"name": "Slovakia", "code": "SK", "dial_code": "+421"},
    {"name": "Slovenia", "code": "SI", "dial_code": "+386"},
    {"name": "Solomon Islands", "code": "SB", "dial_code": "+677"},
    {"name": "Somalia", "code": "SO", "dial_code": "+252"},
    {"name": "South Africa", "code": "ZA", "dial_code": "+27"},
    {"name": "South Sudan", "code": "SS", "dial_code": "+211"},
    {"name": "Spain", "code": "ES", "dial_code": "+34"},
    {"name": "Sri Lanka", "code": "LK", "dial_code": "+94"},
    {"name": "Sudan", "code": "SD", "dial_code": "+249"},
    {"name": "Suriname", "code": "SR", "dial_code": "+597"},
    {"name": "Sweden", "code": "SE", "dial_code": "+46"},
    {"name": "Switzerland", "code": "CH", "dial_code": "+41"},
    {"name": "Syria", "code": "SY", "dial_code": "+963"},
    {"name": "Tajikistan", "code": "TJ", "dial_code": "+992"},
    {"name": "Tanzania", "code": "TZ", "dial_code": "+255"},
    {"name": "Thailand", "code": "TH", "dial_code": "+66"},
    {"name": "Timor-Leste", "code": "TL", "dial_code": "+670"},
    {"name": "Togo", "code": "TG", "dial_code": "+228"},
    {"name": "Tonga", "code": "TO", "dial_code": "+676"},
    {"name": "Trinidad and Tobago", "code": "TT", "dial_code": "+1"},
    {"name": "Tunisia", "code": "TN", "dial_code": "+216"},
    {"name": "Turkey", "code": "TR", "dial_code": "+90"},
    {"name": "Turkmenistan", "code": "TM", "dial_code": "+993"},
    {"name": "Tuvalu", "code": "TV", "dial_code": "+688"},
    {"name": "Uganda", "code": "UG", "dial_code": "+256"},
    {"name": "Ukraine", "code": "UA", "dial_code": "+380"},
    {"name": "United Arab Emirates", "code": "AE", "dial_code": "+971"},
    {"name": "United Kingdom", "code": "GB", "dial_code": "+44"},
    {"name": "United States of America", "code": "US", "dial_code": "+1"},
    {"name": "Uruguay", "code": "UY", "dial_code": "+598"},
    {"name": "Uzbekistan", "code": "UZ", "dial_code": "+998"},
    {"name": "Vanuatu", "code": "VU", "dial_code": "+678"},
    {"name": "Vatican City", "code": "VA", "dial_code": "+379"},
    {"name": "Venezuela", "code": "VE", "dial_code": "+58"},
    {"name": "Vietnam", "code": "VN", "dial_code": "+84"},
    {"name": "Yemen", "code": "YE", "dial_code": "+967"},
    {"name": "Zambia", "code": "ZM", "dial_code": "+260"},
    {"name": "Zimbabwe", "code": "ZW", "dial_code": "+263"}
]


export const flagLink = (code)=>{
  const codeInLink = code.lower()
  return `https://flagcdn.com/w320/${codeInLink}.png`
}